import {Pipe, PipeTransform} from '@angular/core';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';

/**
 * Trusts inline SVG markup for [innerHTML].
 * Extracts the &lt;svg&gt;…&lt;/svg&gt; fragment so XML prologs / HTML comments
 * from SVG Repo downloads do not break browser HTML parsing (icons otherwise
 * appear blank even when the API returns markup).
 */
@Pipe({
  name: 'safeSvg',
  standalone: false,
  pure: true,
})
export class SafeSvgPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    const markup = extractSvgMarkup(value);
    if (!markup) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }
    return this.sanitizer.bypassSecurityTrustHtml(markup);
  }
}

/** Visible for unit tests. */
export function extractSvgMarkup(value: string | null | undefined): string {
  if (value == null) {
    return '';
  }
  const trimmed = String(value).replace(/^\uFEFF/, '').trim();
  if (!trimmed) {
    return '';
  }
  const lower = trimmed.toLowerCase();
  const start = lower.indexOf('<svg');
  if (start < 0) {
    return '';
  }
  const end = lower.lastIndexOf('</svg>');
  if (end > start) {
    return trimmed.substring(start, end + '</svg>'.length);
  }
  return trimmed.substring(start);
}
